
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M23.928 16.965C22.798 14.898 20.56 13.5 18 13.5s-4.798 1.4-5.928 3.465a.597.597 0 000 .57C13.202 19.602 15.44 21 18 21s4.798-1.4 5.928-3.465a.597.597 0 000-.57zM18 20.063c-1.657 0-3-1.26-3-2.813 0-1.553 1.343-2.812 3-2.812s3 1.259 3 2.812c0 .746-.316 1.462-.878 1.99a3.103 3.103 0 01-2.122.823zm0-4.688a2.109 2.109 0 00-.527.074.892.892 0 01-.098 1.215 1.047 1.047 0 01-1.296.092c-.224.774.103 1.596.814 2.043.71.447 1.646.42 2.326-.069.679-.488.95-1.328.675-2.087-.276-.76-1.038-1.27-1.894-1.268zM8.396 10.8A5.398 5.398 0 0013.8 5.396C13.796 2.46 11.34.004 8.404 0A5.398 5.398 0 003 5.404c.004 2.936 2.46 5.392 5.396 5.396zm-.165-8.996a3.603 3.603 0 013.765 3.765A3.612 3.612 0 018.57 8.996a3.603 3.603 0 01-3.765-3.765A3.612 3.612 0 018.23 1.804zM5.04 13.2c.548 0 1.436.6 3.36.6 1.939 0 2.445-.758 3.36-.758s1.51.447 2.008.758l1.682-.907c-1.203-1.077-2.265-1.493-3.69-1.493-1.425 0-1.594.6-3.36.6-1.766 0-2.28-.6-3.36-.6A5.041 5.041 0 000 16.44v.96a1.8 1.8 0 001.8 1.8h9.542v-1.8H1.8v-.96a3.246 3.246 0 013.24-3.24z"}})]),_c('use',{attrs:{"fill":"#969798","transform":"translate(0 2)","xlink:href":"#a"}})])
          )
        }
      }
    